import { getActivityError, getMetricsError } from './metrics'

const getStepsErrors = (activity, metrics) => {
    return {
        0: getActivityError(activity, ['title', 'description', 'test_type']),
        1: getMetricsError(metrics)
    }
}

export {
    getStepsErrors
}